import { Box, Checkbox, FormControlLabel, FormGroup } from "@mui/material"
import { useEffect, useState } from "react"
import { changeStaticData, forestryUse, staticData, summaryData } from "../../appState/summarySignals"


const ForestrySelect: React.FC = () => {
    const [selectedUse, setSelectedUse] = useState<string[]>(staticData.value.forestryUse || [])
    
    // handle the change when a checkbox was clicked
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        if (e.target.checked) {
            setSelectedUse([...selectedUse, forestryUse[index]])
        } else {
            setSelectedUse(selectedUse.filter(u => u !== forestryUse[index]))
        }
    }

    // update the summaryData when the selectedUse changes
    useEffect(() => {
        changeStaticData('forestryUse', selectedUse)
    }, [selectedUse])

    return <>
        <FormGroup>
            {forestryUse.map((usage, index) => (
                <FormControlLabel 
                    key={index}
                    control={<Checkbox 
                            checked={selectedUse.includes(forestryUse[index])} 
                            onChange={e => handleChange(e, index)}
                        />
                    }
                    label={usage}
                />
            ))}
            
        </FormGroup>
    </>
}

export default ForestrySelect